<template>
    <div>
        <el-button type="primary"
                   @click="startStuleTour"
                   :disabled="!tourAvailable">
            {{$t('termRecognitionTour.tourName')}}
        </el-button>

        <el-tour v-model="tourStart"
                 :target-area-clickable="false">

            <el-tour-step :target="translateButtonTarget"
                          :title="$t('termRecognitionTour.translate')">
                <div>{{translateDescription}}</div>
            </el-tour-step>

            <el-tour-step :target="variantsButtonTarget"
                          :title="$t('termRecognitionTour.terminologyRecognized')"
                          :content-style="variantsButtonStyle"
                          placement="left">

                <div>{{$t('termRecognitionTour.terminologyRecognizedDescription')}}</div>

                <img class="screenshot"
                     src="@/images/Tours/term-recognition-tour-1.png"
                     alt="tour.png" />
            </el-tour-step>

            <el-tour-step :target="variantsButtonTarget"
                          :title="$t('termRecognitionTour.terminologyLoaded')"
                          :content-style="variantsButtonStyle"
                          placement="left">

                <div>{{$t('termRecognitionTour.terminologyLoadedDescription')}}</div>

                <img class="screenshot"
                     src="@/images/Tours/term-recognition-tour-2.png"
                     alt="tour.png" />
            </el-tour-step>


        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { shortcuts } from '@/utils/shortcuts';

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                tourStart: false,

                translateButtonTarget: "#translate-button",
                translateDescription: this.$t('termRecognitionTour.translateDescription', [shortcuts.translate.win]),

                variantsButtonTarget: "#variants-button",
                variantsButtonStyle: { width: '800px' },
            };
        },

        methods: {
            startStuleTour() {
                const result = document.getElementById("shortcut-button");
                if (result != null) {
                    result.click();
                }
                this.tourStart = true;
            },
        },


    })
</script>

<style scoped>
    .screenshot {
        max-width: 100%;
        margin-top: 10px;
    }
</style>